// Libraries
import {htmlToText as htmlToTextLibrary} from 'html-to-text';

const htmlToText = (html: string) => {
  return htmlToTextLibrary(html, {
    selectors: [
      {selector: 'a', options: {ignoreHref: true}},
      {selector: 'img', format: 'skip'},
      // The library defaults to capitalizing headings, disable that
      ...['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].map((tag) => ({
        selector: tag,
        options: {uppercase: false},
      })),
    ],
    // Don't display multiple newlines in a row
  }).replace(/\n{3,}/g, '\n\n');
};

export default htmlToText;
